<script setup lang="ts">
const props = defineProps<{
  message: string
  retryable?: boolean
}>()

const emit = defineEmits<{
  retry: []
}>()
</script>

<template>
  <div class="error-display">
    <div class="error-display__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
    </div>
    <p class="error-display__message">{{ message }}</p>
    <button
      v-if="retryable"
      class="error-display__retry"
      @click="emit('retry')"
    >
      Prøv igjen
    </button>
  </div>
</template>

<style scoped lang="scss">
.error-display {
  text-align: center;
  padding: 2rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;

  &__icon {
    color: #dc2626;
    margin-bottom: 0.5rem;
  }

  &__message {
    color: #991b1b;
    margin-bottom: 1rem;
  }

  &__retry {
    background: #dc2626;
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;

    &:hover { background: #b91c1c; }
  }
}
</style>
